
export const fillColors1 = (c, data, index) => {
    data[index    ] = c.r;
    data[index + 1] = c.g;
    data[index + 2] = c.b;
    data[index + 3] = c.a ?? 255;
}